import { useMemo } from "react";

type FullEvalHeaderProps = {
  answeredCount: number;
  totalCount: number;
};

function FullEvalHeader({ answeredCount, totalCount }: FullEvalHeaderProps) {
  const percentage = useMemo(
    () => (totalCount > 0 ? Math.round((answeredCount / totalCount) * 100) : 0),
    [answeredCount, totalCount]
  );

  return (
    <div
      className="rounded-xl p-6 text-white relative overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #0F2440 0%, #1A3A5C 50%, #0D1F36 100%)",
      }}
    >
      <div
        className="absolute top-0 right-0 w-48 h-48 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(59,130,246,0.12) 0%, transparent 70%)",
        }}
      />

      <div className="flex items-start justify-between gap-6 relative">
        <div className="flex-1 min-w-0">
          <div
            className="text-[10px] font-bold tracking-[2.5px] mb-2"
            style={{ color: "#60A5FA" }}
          >
            NIS2 EVALUARE COMPLETĂ
          </div>
          <h1 className="text-xl font-bold text-white leading-snug mb-1">
            Evaluarea Maturității Conform DNSC
          </h1>
          <p className="text-sm" style={{ color: "#94A3B8" }}>
            Evaluați fiecare cerință pe o scală de la 1 la 5, atât pentru
            documentație cât și pentru implementare.
          </p>
        </div>

        <div className="text-right shrink-0">
          <div
            className="text-4xl font-black leading-none"
            style={{ color: "#60A5FA", fontVariantNumeric: "tabular-nums" }}
          >
            {percentage}%
          </div>
          <div className="text-xs mt-1" style={{ color: "#94A3B8" }}>
            {answeredCount}/{totalCount} cerințe
          </div>
        </div>
      </div>

      <div
        className="mt-5 h-1.5 rounded-full overflow-hidden"
        style={{ background: "rgba(255,255,255,0.08)" }}
      >
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${percentage}%`,
            background: "linear-gradient(90deg, #3B82F6, #60A5FA)",
          }}
        />
      </div>
    </div>
  );
}

export default FullEvalHeader;
